import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ProcessDetail from './components/ProcessDetail';
import { getTokens, clearTokens } from './api';
import './App.css';

function App() {
  const [user, setUser]               = useState(null);
  const [currentView, setCurrentView] = useState({ type: 'dashboard', data: null });

  useEffect(() => {
    // Verificar se há sessão ativa (tokens válidos)
    const { idToken, expiresAt } = getTokens();
    if (idToken && Date.now() < expiresAt) {
      const email     = localStorage.getItem('userEmail') || '';
      const empresaId = localStorage.getItem('empresaId') || 'default';
      setUser({ email, empresaId });
    }

    // Verificar se URL tem parâmetro de processo (nova aba)
    const params = new URLSearchParams(window.location.search);
    const processParam = params.get('process');
    if (processParam) {
      try {
        const processData = JSON.parse(decodeURIComponent(processParam));
        setCurrentView({ type: 'processDetail', data: processData });
      } catch (e) {
        console.error('Parâmetro de processo inválido');
      }
    }
  }, []);

  const handleLogin = ({ email, empresaId }) => {
    localStorage.setItem('userEmail', email);
    localStorage.setItem('empresaId', empresaId);
    setUser({ email, empresaId });
  };

  const handleLogout = () => {
    clearTokens();
    setUser(null);
    setCurrentView({ type: 'dashboard', data: null });
  };

  const navigateTo = (view, data = null) => {
    setCurrentView({ type: view, data });
  };

  // Tela de processo em nova aba — exige autenticação
  if (currentView.type === 'processDetail') {
    if (!user) return <Login onLogin={handleLogin} />;
    return (
      <ProcessDetail
        process={currentView.data}
        onBack={() => window.close()}
      />
    );
  }

  if (!user) return <Login onLogin={handleLogin} />;

  return (
    <Dashboard
      user={user}
      onLogout={handleLogout}
      onNavigate={navigateTo}
      currentTab={currentView.type}
    />
  );
}

export default App;
